/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharerulefairness2Inputs */

const en_sharerulefairness2 = /** @type {(inputs: Sharerulefairness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visits by you and your team never count. Unusually many visits from one network or within a short time are reviewed before they are credited.`)
};

const de_sharerulefairness2 = /** @type {(inputs: Sharerulefairness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine eigenen Besuche und die deines Teams zählen nicht. Auffällig viele Besuche aus einem Netz oder in kurzer Zeit prüfen wir, bevor sie gutgeschrieben werden.`)
};

/**
* | output |
* | --- |
* | "Visits by you and your team never count. Unusually many visits from one network or within a short time are reviewed before they are credited." |
*
* @param {Sharerulefairness2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharerulefairness2 = /** @type {((inputs?: Sharerulefairness2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharerulefairness2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharerulefairness2(inputs)
	return de_sharerulefairness2(inputs)
});
export { sharerulefairness2 as "shareRuleFairness" }